<template>

    <table class="table bg-ss-gray orderconfirmtable">
        <tr>
            <td>
                <div>
                    <strong>{{ lang('all.bestelnummer') }}</strong>
                    #{{ order.data.number }}
                </div>
            </td>
            <td>
                <div>
                    <strong>{{ lang('all.datum') }}</strong>
                    {{ orderDate }}
                </div>
            </td>
            <td>
                <div>
                    <strong>{{ lang('all.betaalwijze') }}</strong>
                    {{ order.data.paymentmethod.name }}
                </div>
            </td>
            <td>
                <div>
                    <strong>{{ lang('all.betaalstatus') }}</strong>
                    {{ order.data.paymentmethod.status }}
                </div>
            </td>
        </tr>
        <tr>
            <td>
                <div>
                    <strong>{{ lang('all.bestelstatus') }}</strong>
                    {{ order.data.status }}
                </div>
            </td>
            <td>
                <div>
                    <strong>{{ lang('all.totaal') }}</strong>
                    {{ order.data.totalamount | toCurrency }}
                </div>
            </td>
            <td>
                <div>
                    <strong>{{ lang('all.verzendwijze') }}</strong>
                    {{ order.data.shippingmethod.name }}
                </div>
            </td>
            <td>
                <div>
                    <strong>{{ lang('all.verzendstatus') }}</strong>
                    {{ order.data.shippingmethod.status }}
                </div>
            </td>
        </tr>
        <tr v-if="order.data.invoice">
            <td>
                <div>
                    <strong>Factuur nummer</strong>
                    {{ order.data.invoice.number }}
                </div>
            </td>
            <td>
                <div>
                    <strong>Factuur datum</strong>
                    {{ invoiceDate }}
                </div>
            </td>
            <td>
                <div>
                    <strong>Factuur totaal</strong>
                    {{ order.data.invoice.total | toCurrency }}
                </div>
            </td>
            <td class="text-center">
                <div>
                    <a
                        :href="route('auth.myaccount.invoices.download', {uuid: order.data.invoice.id})"
                        target="_blank"
                        v-tooltip="lang('invoices.download')"
                        class="btn btn-primary btn-sm mb-0"
                    >
                        <i class="mdi mdi-download"></i>
                        <span class="sr-only">
                            {{ lang('invoices.download') }}
                        </span>
                    </a>
                </div>
            </td>
        </tr>
    </table>

</template>

<script>

import moment from "moment";

export default {

    computed: {
        orderDate() {
            return moment(this.order.data.date).format('D MMMM YYYY');
        },
        invoiceDate() {
            return this.order.data.invoice ?
                moment(this.order.data.invoice.date).format('D MMMM YYYY') :
                '';
        }
    },

    name:'OrdersConfirmationTable',

    props: {
        order: {
            required:true,
            type:Object,
        },
    },

}

</script>

<style>

.orderconfirmtable tr > td:not(:first-child) > div {
    border-left:2px dotted #dee2e6;
    padding:0 10px;
}
.orderconfirmtable tr > td > div > strong {
    display:block;
}

</style>
